import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  EntityCardContainer,
  EntityCardTitle,
  EntityCardMaterialIcon,
} from '../../../entity/components/EntityCardComponents';
import { EntityCardItemWithIcon } from '../../../entity/components/EntityCardItemWithIcon';
import { LawyerContext } from '../LawyerContext';

export const LawyerSpecialisations: FC = () => {
  const {
    lawyerInfos: { skills, specialisations },
  } = useContext(LawyerContext);
  const hasSkills = skills.length > 0;
  const hasSpecialisations = specialisations && specialisations.length > 0;
  if (hasSkills || hasSpecialisations) {
    window.dispatchEvent(
      new CustomEvent('createNav', {
        detail: 'professional-skills',
      }),
    );
  }
  if (!hasSkills && !hasSpecialisations) return null;
  return (
    <EntityCardContainer id="professional-skills">
      {(hasSkills || hasSpecialisations) && (
        <EntityCardTitle>
          <FormattedMessage id="app.pages.lawyer.specialty.title" />
        </EntityCardTitle>
      )}
      {specialisations && specialisations.length > 0 && (
        <EntityCardItemWithIcon
          icon={<EntityCardMaterialIcon name="stars" />}
          subtitle={
            <FormattedMessage
              id="app.pages.lawyer.specialty.official"
              values={{ numberOfSpecialties: specialisations.length }}
            />
          }
          text={specialisations.map(specialisation => (
            <div key={specialisation}>{specialisation}</div>
          ))}
        />
      )}

      {hasSkills && (
        <EntityCardItemWithIcon
          icon={<EntityCardMaterialIcon name="check_circle" />}
          subtitle={
            <FormattedMessage
              id="app.pages.lawyer.specialty.domain"
              values={{ numberOfSkills: skills.length }}
            />
          }
          text={skills.map(skill => (
            <div key={skill}>{skill}</div>
          ))}
        />
      )}
    </EntityCardContainer>
  );
};
